interface RedirectModalArgs {
  name: string
  params?: Record<string, string | boolean>
}

const useNativeModalRedirect = () => {
  const redirectToModal = ({ name, params }: RedirectModalArgs) => {}

  return { redirectToModal }
}

export default useNativeModalRedirect
